import {
  required,
  min_value,
  oneOf,
  max_value,
  is,
  between,
} from 'vee-validate/dist/rules'
import { extend } from 'vee-validate'

extend('required', {
  ...required,
  message: 'Obbligatorio',
})

extend('is', {
  ...is,
  message: 'Obbligatorio (is)',
})

extend('min_value', {
  ...min_value,
  message: 'Inserire un valore maggiore di 0',
})
extend('min_valuex', {
  ...min_value,
  message: 'Inserire un valore maggiore di {min}',
})

extend('max_value', {
  ...max_value,
  message: 'Inserire un valore minore o uguale a {max}',
})

extend('between', {
  ...between,
  message: 'Inserire un valore compreso tra {min} e {max}',
})

extend('oneOfTypes', {
  ...oneOf,
  message: 'Non compatibile con il tipo di merce',
})

extend('required', {
  ...required,
  message: 'Obbligatorio',
})

extend('even', value => {
  if (value % 2 === 0) {
    return true
  }

  return 'Inserire un numero pari'
})

extend('required_empty', {
  ...required,
  message: 'Selezionare o aggiungere una merce',
})

extend('is_empty', value => {
  if (value === '') {
    return true
  }

  return 'Il campo deve essere vuoto'
})
